import { Guid } from 'Lib/Guid';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../Data/ReduxViewModels/WorksheetGrid';
import { Button, IButtonProps } from '../../../Core';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';

type WorksheetGridRequestButtonProps = Omit<IButtonProps, 'onClick'> & {
  endpoint: string;
  worksheetId: Guid;
};

let idCounter = 0;

// Component that triggers a request for a worksheet within the worksheet grid
// Used where we have individual endpoints for complex actions
let WorksheetGridRequestButton: React.FC<React.PropsWithChildren<WorksheetGridRequestButtonProps>> = ({
  endpoint,
  worksheetId,
  children,
  disabled,
  ...otherProps
}) => {
  const dispatch = useDispatch();
  const [requestId] = useState(`worksheetGridRequest-${idCounter++}`);

  const isInProgress = useSelector((state) => state.worksheetGrid.requests[requestId]?.inProgress);

  return (
    <Button
      loading={isInProgress}
      disabled={disabled || isInProgress}
      onClick={() =>
        dispatch(
          actions.postRequest({
            endpoint,
            worksheetId,
            requestId,
          })
        )
      }
      {...otherProps}
    >
      {children}
    </Button>
  );
};

WorksheetGridRequestButton = withInjectedProps(WorksheetGridRequestButton);

export default WorksheetGridRequestButton;
export { WorksheetGridRequestButton };
